import * as betprofessor from './RaceNumber.styles.betprofessor';
import * as templebet from './RaceNumber.styles.templebet';
import { EThemesOG } from '@/constants/themeConfig';

export const styleImports: Partial<Record<EThemesOG, any>> = {
  betprofessor,
  templebet,
};
